import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const AreaTooltipStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "area-tooltip",
})`
  .area-tooltip__title {
    margin-top: 7px;
    font-size: 11px;
  }
`;
